export default {"LABEL":"Installation 安装","DESC":"语义化的矢量图形。","COMPONENTS":{"__markdown":true}}